import { createTheme } from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import buildComponents from './components';

const base = createTheme({
  palette: palette,
  typography: typography,
});

const theme = createTheme(base, {
  components: buildComponents(base),
});

export default theme;
